import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {APIClient} from "../../../helpers/ApiHelper";


export const getInApp = createAsyncThunk(
    "getInApp",
    async ({ clientId }) => {
        try {
            // Use your APIClient instance
            const apiClient = new APIClient();

            const response = await apiClient.get(`/api/v1/analytic/device/in-app/${clientId}`);
            return response.data;
        } catch (error) {
            throw error;
        }
    }
);


export const inAppSlice = createSlice({
    name: "InAppSlice",
    initialState: {
        loading: false,
        payload: {},
        mostUsedServiceName: "",
        mostUsedServiceCount: 0,
        mostViewServiceName: "",
        mostViewServiceCount: 0,
        lastActivity: ""
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getInApp.pending, (state) => {
                state.loading = true;
                state.payload= {};
                state.mostUsedServiceName = "";
                state.mostUsedServiceCount = 0;
                state.mostViewServiceName= "";
                state.mostUsedServiceCount= 0;
                state.lastActivity = "";
            })
            .addCase(getInApp.fulfilled, (state, action) => {
                state.loading = false;
                state.payload = action.payload;

                state.mostUsedServiceCount = action.payload.mostUsedServiceCount;
                state.mostUsedServiceName = action.payload.mostUsedServiceName;
                state.mostViewServiceCount = action.payload.mostViewServiceCount;
                state.mostViewServiceName = action.payload.mostViewServiceName;
                state.lastActivity = action.payload.lastActivity;
            })
            .addCase(getInApp.rejected, (state) => {
                state.loading = false;
            });
    },
});

export default inAppSlice.reducer;
